import LayoutBasic from "@/views/layouts/LayoutBasic";
import CardReport from "@/views/cards/Report";
import settingsCardsNew from "@/views/admin/settings/cards/new";
import CashOut from "@/views/cards/CashOut.vue";
import CardsTransactions from "@/views/cards/Transactions.vue";
import Statistics from "@/views/cards/Statistics.vue";

const routes = {
  path: '/cards',
  component: LayoutBasic, // Change the desired Layout here
  meta: {requiresAuth: true},
  children: [
    {
      path: 'report',
      name: 'NoCashCardReport',
      component: CardReport
    },
    {
      path: 'show',
      name: 'settingsCardsNew',
      component: settingsCardsNew
    },
    {
      path: 'cashout',
      name: 'CardsCashOut',
      component: CashOut
    },
    {
      path: 'transactions',
      name: 'CardsTransactions',
      component: CardsTransactions
    },
    {
      path: 'statistics',
      name: 'CardsTransactionsStatistics',
      component: Statistics
    },
  ]
};

export default routes;
